import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isCreatingDepartment: false,
  isDeletingDepartment: false,
  isEditingDepartment: false,
  departments: [],
};

export const departmentsSlice = createSlice({
  name: "departments",
  initialState,
  reducers: {
    getDepartmentsStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getDepartmentsSuccess: (state, action) => {
      state.isLoading = false;
      state.departments = action.payload;
      state.error = null;
    },
    getDepartmentsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createDepartmentStart: (state, action) => {
      state.isCreatingDepartment = true;
      state.error = null;
    },
    createDepartmentSuccess: (state, action) => {
      state.isCreatingDepartment = false;
      state.error = null;
    },
    createDepartmentFailure: (state, action) => {
      state.isCreatingDepartment = false;
      state.error = action.payload;
    },
    editDepartmentStart: (state, action) => {
      state.isEditingDepartment = true;
      state.error = null;
    },
    editDepartmentSuccess: (state, action) => {
      state.isEditingDepartment = false;
      state.error = null;
    },
    editDepartmentFailure: (state, action) => {
      state.isEditingDepartment = false;
      state.error = action.payload;
    },
    deleteDepartmentStart: (state, action) => {
      state.isDeletingDepartment = true;
      state.error = null;
    },
    deleteDepartmentSuccess: (state, action) => {
      state.isDeletingDepartment = false;
      state.error = null;
    },
    deleteDepartmentFailure: (state, action) => {
      state.isDeletingDepartment = false;
      state.error = action.payload;
    },
  },
});

export const {
  getDepartmentsFailure,
  getDepartmentsSuccess,
  getDepartmentsStart,
  createDepartmentFailure,
  createDepartmentStart,
  createDepartmentSuccess,
  editDepartmentFailure,
  editDepartmentStart,
  editDepartmentSuccess,
  deleteDepartmentFailure,
  deleteDepartmentStart,
  deleteDepartmentSuccess

} = departmentsSlice.actions;

const departmentsReducer = departmentsSlice.reducer;
export default departmentsReducer;
